import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { verifyMfaCode } from "../../../services/security-services/SecurityActions";
import { getPortfolio } from "../../../services/portfolio-services/portfolioActions";

const schema = yup.object().shape({
  code: yup.string().required("Code is required").length(6, "Code must be 6 digits"),
});

export default function MfaVerificationForm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { error, isFetching } = useSelector((state) => state.security);
  const [formattedCode, setFormattedCode] = useState("");

  const {
    register,
    handleSubmit,
    setValue,

    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = async ({ code }) => {
    const result = await dispatch(verifyMfaCode(code));
    if (result?.type === "LOGIN_SUCCESS") {
      await dispatch(getPortfolio());
      navigate("/office/global");
    } else {
      toast.error("Invalid MFA code.");
    }
  };

  const formatCode = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 6);
    const parts = digits.match(/.{1,2}/g) || [];
    return parts.join(" - ");
  };

  const handleCodeChange = (e) => {
    const raw = e.target.value;
    const formatted = formatCode(raw);
    setFormattedCode(formatted);
    setValue("code", raw.replace(/\D/g, "").slice(0, 6));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="text-left">

      <div className="mb-3">
        <button
          type="button"
          onClick={() => navigate("/login")}
          className="btn btn-link p-0 text-decoration-none"
          style={{
            color: "#9333ea",
            fontWeight: 500,
            fontSize: "0.95rem",
            display: "flex",
            alignItems: "center",
            gap: "0.4rem",
          }}
        >
          <i className="fa fa-chevron-left" /> Back to login
        </button>
      </div>

      {/* Code field */}

      <div className="form-group mb-3 d-flex justify-content-center">
        <div style={{ width: "250px" }}>
          <label htmlFor="code" className="mb-1 fw-medium d-block text-center">6-digit Code</label>

          <input
            type="text"
            id="code"
            inputMode="numeric"
            placeholder="XX - XX - XX"
            value={formattedCode}
            onChange={handleCodeChange}
            className={classNames("form-control border rounded shadow-sm text-center", {
              "is-invalid": errors.code,
            })}
            style={{
              fontFamily: "monospace",
              letterSpacing: "2px",
              fontSize: "1.15rem",
              padding: "0.6rem 0.75rem",
            }}
          />
          <input type="hidden" name="code" />
        </div>
      </div>


      <div className="invalid-feedback d-block">{errors.code?.message}</div>

      {error && (
        <div className="alert alert-danger font-weight-bold mt-2">{error}</div>
      )}

      <button
        type="submit"
        className="btn w-100 py-2 fw-semibold text-white"
        disabled={isFetching}
        style={{
          background: "linear-gradient(90deg, #7c3aed, #2563eb)",
          border: "none",
          borderRadius: "0.6rem",
        }}
      >
        {isFetching ? (
          <span className="spinner-border spinner-border-sm" role="status" />
        ) : (
          "Verify Code"
        )}
      </button>
    </form>
  );
}
